<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" class="full-width-table">

    <!-- Username -->
    <ng-container matColumnDef="Usuario">
      <th mat-header-cell *matHeaderCellDef> Username </th>
      <td mat-cell *matCellDef="let element"> {{element.username}} </td>
    </ng-container>

    <!-- IsActivated -->
    <ng-container matColumnDef="Activado">
      <th mat-header-cell *matHeaderCellDef> Activated </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon color="primary" *ngIf="element.isActivated">check_circle</mat-icon>
        <mat-icon color="warn" *ngIf="!element.isActivated">cancel</mat-icon>
      </td>
    </ng-container>

    <!-- IsSubscribed -->
    <ng-container matColumnDef="Suscrito">
      <th mat-header-cell *matHeaderCellDef> Subscribed </th>
      <td mat-cell *matCellDef="let element">
        <mat-chip-option color="primary" *ngIf="element.isSubscribed" selected>Yes</mat-chip-option>
        <mat-chip-option color="warn" *ngIf="!element.isSubscribed" selected>X</mat-chip-option>
      </td>
    </ng-container>

    <!-- Datetime -->
    <ng-container matColumnDef="Fecha Creación">
      <th mat-header-cell *matHeaderCellDef> Created </th>
      <td mat-cell *matCellDef="let element"> {{element.datetime | date:'short'}} </td>
    </ng-container>

    <!-- SubscriptionEndDate -->
    <ng-container matColumnDef="Fecha Fin Subscripción">
      <th mat-header-cell *matHeaderCellDef> End Date </th>
      <td mat-cell *matCellDef="let element"> {{element.subscriptionEndDate | date:'shortDate'}} </td>
    </ng-container>

    <!-- Subscription -->
    <ng-container matColumnDef="Subscripción">
      <th mat-header-cell *matHeaderCellDef> Subscription </th>
      <td mat-cell *matCellDef="let element"> {{element.subscription}} </td>
    </ng-container>

    <!-- Price -->
    <ng-container matColumnDef="Precio">
      <th mat-header-cell *matHeaderCellDef> Price </th>
      <td mat-cell *matCellDef="let element"> {{element.price}} </td>
    </ng-container>

    <!-- Header & Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
